module.exports = __webpack_public_path__ + "static/media/unlocked-icon.9c1d2707.svg";